import { api } from './auth.service';

const crmAcaoService = {

  // Lista as ações de um negócio (mais recentes primeiro)
  listarPorNegocio: async (negocioId) => {
    const res = await api.get(`/crm-acoes/negocio/${negocioId}`);
    return res.data;
  },

  // Cria nova ação
  // dados = { data_acao: 'YYYY-MM-DD', detalhes: '...', colaborador_id: '...' }
  criar: async (negocioId, dados) => {
    const res = await api.post(`/crm-acoes/negocio/${negocioId}`, dados);
    return res.data;
  },
};

export default crmAcaoService;
